export const DOMAIN = "https://movie0706.cybersoft.edu.vn";
export const TOKEN = "accessToken";
export const USER_LOGIN = "userLogin";
export const GROUP_ID = "GP02";
